import { StraightenerLimitsManager } from "./components/StraightenerLimitsManager";

export const StraightenerLimitsPage = () => <StraightenerLimitsManager />;
